@font-face {
  font-family: "Proxima Nova";
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src:
    local("Proxima Nova Light"),
    local("Proxima Nova"),
    url("https://assets.xendit.co/payment-session/fonts/proxima-nova/proximanova_light.otf")
      format("opentype");
}

@font-face {
  font-family: "Proxima Nova";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src:
    local("Proximanova Regular"),
    local("Proxima Nova"),
    url("https://assets.xendit.co/payment-session/fonts/proxima-nova/proximanova_regular.ttf")
      format("truetype");
}

@font-face {
  font-family: "Proxima Nova";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src:
    local("Proxima Nova Bold"),
    local("Proxima Nova"),
    url("https://assets.xendit.co/payment-session/fonts/proxima-nova/proximanova_bold.otf")
      format("opentype"),
    url("https://assets.xendit.co/payment-session/fonts/proxima-nova/proximanova_boldit.otf")
      format("opentype"),
    url("https://assets.xendit.co/payment-session/fonts/proxima-nova/proximanova_extrabold.otf")
      format("opentype");
}

@font-face {
  font-family: "Proxima Nova";
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src:
    local("Proxima Nova Black"),
    local("Proxima Nova"),
    url("https://assets.xendit.co/payment-session/fonts/proxima-nova/proximanova_black.otf")
      format("opentype"),
    url("https://assets.xendit.co/payment-session/fonts/proxima-nova/proximanova_blackit.otf")
      format("opentype"),
    url("https://assets.xendit.co/payment-session/fonts/proxima-nova/proximanova_black.ttf")
      format("truetype");
}

/* variables */
html {
  --xendit-font-family: "Proxima Nova", sans-serif;
  --xendit-color-primary: #1762ee;
  --xendit-color-text: #252525;
  --xendit-color-text-secondary: #585858;
  --xendit-color-text-placeholder: #7d7d7d;
  --xendit-color-disabled: #f7f7f7;
  --xendit-color-danger: #d1414d;
  --xendit-color-border: rgba(0, 0, 0, 0.05);
  --xendit-color-border-subtle: rgba(243, 243, 243);
  --xendit-color-border-default: #ededed;
  --xendit-color-background: #ffffff;
  --xendit-focus-shadow: 0px 0px 0px 2px
    color-mix(in srgb, var(--xendit-color-primary) 15%, transparent);
  --xendit-animation-duration: 0.3s;
  --xendit-animation-ease: ease-in-out;
  --xendit-radius-1: 8px;
  --xendit-z-index-focus: 2;

  /* Browser-specific border collapse margins */
  --xendit-border-collapse-offset: -0.5px; /* Default for Chrome/Edge */
  --xendit-border-collapse-webkit-gecko: -1.5px; /* Fix Safari and Firefox subpixel rendering */
}

/* Set default font for root components */
xendit-channel-picker,
xendit-action-container,
xendit-payment-channel {
  display: block;
  unicode-bidi: isolate;
  font-family: var(--xendit-font-family, sans-serif);
  color: var(--xendit-color-text);
}

.xendit-default-action-container {
  font-family: var(--xendit-font-family, sans-serif);
}

xendit-action-container {
  background-color: var(--xendit-color-background);
}

xendit-payment-channel button,
xendit-payment-channel textarea,
xendit-payment-channel select,
xendit-payment-channel input,
xendit-payment-channel input::placeholder {
  font-family: inherit;
}

xendit-payment-channel input::placeholder,
xendit-payment-channel textarea::placeholder,
xendit-payment-channel select::placeholder {
  color: var(--xendit-color-text-placeholder);
}

/* Reusable typography classes */
.xendit-text-12 {
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.01px;
}

.xendit-text-14 {
  font-size: 14px;
  line-height: 16px;
  letter-spacing: -0.09px;
}

.xendit-text-16 {
  font-size: 16px;
  line-height: 16px;
  letter-spacing: -0.09px;
}

.xendit-text-12,
.xendit-text-14,
.xendit-text-16 {
  font-weight: 400;
}

.xendit-text-semibold {
  font-weight: 600;
}

.xendit-text-bold {
  font-weight: 700;
}

.xendit-text-secondary {
  color: var(--xendit-color-text-secondary);
}

/* Accordion component */

.xendit-accordion {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.xendit-accordion-item {
  border: 1px solid var(--xendit-color-border);
  border-radius: 8px;
  background: var(--xendit-color-background);
}

.xendit-accordion-item-header {
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-gap: 16px;
  align-items: center;
  cursor: pointer;
  padding: 24px 16px;
  color: var(--xendit-color-text);
  border-radius: 8px;
}

.xendit-accordion-item-disabled.xendit-accordion-item {
  background-color: var(--xendit-color-disabled);
  border-color: var(--xendit-color-disabled);
}

.xendit-accordion-item-disabled .xendit-accordion-item-header {
  cursor: not-allowed;
}

.xendit-accordion-item-header-title {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.xendit-accordion-item-disabled .xendit-accordion-item-header-title,
.xendit-accordion-item-disabled .xendit-accordion-item-header-icon {
  opacity: 0.5;
}

.xendit-accordion-item.xendit-accordion-item-open
  .xendit-accordion-item-header {
  color: var(--xendit-color-primary);
}

.xendit-accordion-item-chevron {
  color: var(--xendit-color-text);
}

.xendit-accordion-item-disabled .xendit-accordion-item-chevron {
  display: none;
}

.xendit-accordion-item-chevron g {
  transition: transform var(--xendit-animation-duration)
    var(--xendit-animation-ease);
}

.xendit-accordion-item-header:focus-visible {
  border-radius: 8px;
  box-shadow: 0px 0px 0px 2px
    color-mix(in srgb, var(--xendit-color-primary) 15%, transparent);
  outline: none;
}

.xendit-accordion-item-content {
  overflow: hidden;
  transition: height var(--xendit-animation-duration)
    var(--xendit-animation-ease);
}

.xendit-accordion-item.xendit-accordion-item-closed
  .xendit-accordion-item-content {
  height: 0;
}

.xendit-accordion-item.xendit-accordion-item-open
  .xendit-accordion-item-content {
  height: calc-size(auto, size);
}

.xendit-accordion-item-padding {
  padding: 16px;
}

/* Channel picker group */

.xendit-channel-picker-group {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.xendit-channel-picker-group select {
  border: 1px solid var(--xendit-color-border);
  border-radius: 8px;
  padding: 12px;
  appearance: none;
  outline: none;
}

.xendit-channel-picker-group select:focus {
  box-shadow: 0px 0px 0px 2px
    color-mix(in srgb, var(--xendit-color-primary) 15%, transparent);
}

.xendit-channel-logo {
  width: 24px;
  height: 16px;
  margin: -5px 0;
  padding: 4px;
  border: 1px solid var(--xendit-color-border-default);
  border-radius: 4px;
  background-color: white; /* always white, not --xendit-color-background */
  object-fit: contain;
}

/* Payment channel */

xendit-payment-channel[inert] {
  filter: opacity(0.5) grayscale(1);
}

.xendit-payment-channel {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.xendit-payment-channel-instructions {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 12px;
  color: var(--xendit-color-text-secondary);
}

.xendit-payment-channel-instructions-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
}

.xendit-payment-channel-instructions-text p {
  margin: 0;
}

/* Forms */

.xendit-channel-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.xendit-channel-form > form {
  display: contents;
}

.xendit-form-field-group {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.xendit-channel-form-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.xendit-channel-form-field-group {
  display: grid;
  gap: 8px;
}

.xendit-channel-form-field-group label {
  width: fit-content;
  cursor: pointer;
}

.xendit-form-field-group.invalid .xendit-channel-form-field input,
.xendit-form-field-group.invalid
  .xendit-channel-form-field
  .xendit-iframe-container,
.xendit-form-field-group.invalid .xendit-dropdown button {
  border: 1px solid var(--xendit-color-danger);
}

.xendit-channel-form-field input:not([type="checkbox"]),
.xendit-channel-form-field select,
.xendit-channel-form-field .xendit-iframe-container {
  display: flex;
  border: 1px solid var(--xendit-color-border-subtle);
  background: var(--xendit-color-background);
  border-radius: 8px;
  padding: 12px;
  appearance: none;
}

/* TODO: Refine these class usages */
.xendit-channel-form-field.field-radius-tl-0 input,
.xendit-channel-form-field.field-radius-tl-0 button,
.xendit-channel-form-field.field-radius-tl-0 .xendit-iframe-container {
  border-top-left-radius: 0;
}

.xendit-channel-form-field.field-radius-tr-0 input,
.xendit-channel-form-field.field-radius-tr-0 button,
.xendit-channel-form-field.field-radius-tr-0 .xendit-iframe-container {
  border-top-right-radius: 0;
}

.xendit-channel-form-field.field-radius-bl-0 input,
.xendit-channel-form-field.field-radius-bl-0 button,
.xendit-channel-form-field.field-radius-bl-0 .xendit-iframe-container {
  border-bottom-left-radius: 0;
}

.xendit-channel-form-field.field-radius-br-0 input,
.xendit-channel-form-field.field-radius-br-0 button,
.xendit-channel-form-field.field-radius-br-0 .xendit-iframe-container {
  border-bottom-right-radius: 0;
}

.xendit-channel-form-field.field-collapse-l,
.xendit-channel-form-field.field-collapse-l {
  margin-left: var(--xendit-border-collapse-offset);
}

.xendit-channel-form-field.field-collapse-r,
.xendit-channel-form-field.field-collapse-r {
  margin-right: var(--xendit-border-collapse-offset);
}

.xendit-channel-form-field.field-collapse-l .xendit-iframe-container {
  margin-left: calc(var(--xendit-border-collapse-offset) * 2);
  width: calc(100% + abs(var(--xendit-border-collapse-offset) * 2));
}

.xendit-channel-form-field.field-collapse-r .xendit-iframe-container {
  margin-right: 0;
}

.xendit-channel-form-field.field-collapse-t input,
.xendit-channel-form-field.field-collapse-t button,
.xendit-channel-form-field.field-collapse-t .xendit-iframe-container {
  margin-top: var(--xendit-border-collapse-offset);
}

.xendit-channel-form-field.field-collapse-b input,
.xendit-channel-form-field.field-collapse-b button,
.xendit-channel-form-field.field-collapse-b .xendit-iframe-container {
  margin-bottom: var(--xendit-border-collapse-offset);
}

/* Safari and Firefox specific adjustments */
@supports (font: -apple-system-body) or (-moz-appearance: none) {
  .xendit-channel-form-field.field-collapse-l .xendit-iframe-container {
    margin-left: 0;
    width: 100%;
  }

  .xendit-channel-form-field.field-collapse-b input,
  .xendit-channel-form-field.field-collapse-b button {
    margin-bottom: var(--xendit-border-collapse-webkit-gecko);
    height: calc(100% + abs(var(--xendit-border-collapse-webkit-gecko) * 2));
  }
}

.xendit-channel-form-field.field-collapse-r .xendit-iframe-container:focus {
  border-right: none;
}

.xendit-channel-form-field.field-collapse-l .xendit-iframe-container:focus {
  border-left: none;
}
/* Ends TODO */

.xendit-card-brand-logo {
  width: 24px;
  height: 16px;
  border: 1px solid var(--xendit-color-border-default);
  border-radius: 4px;
  padding: 4px;
  background-color: white; /* always white, not --xendit-color-background */
}

.xendit-card-brands-list {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  gap: 4px;
}

.xendit-channel-form-field input:focus,
.xendit-channel-form-field select:focus,
.xendit-channel-form-field .xendit-iframe-container.xendit-field-focus {
  border-color: var(--xendit-color-primary);
  box-shadow: var(--xendit-focus-shadow);
  outline: none;
  z-index: var(--xendit-z-index-focus);
}

.xendit-channel-form-field button:focus {
  position: relative;
  z-index: var(--xendit-z-index-focus);
}

.xendit-channel-form-field .xendit-iframe-container {
  height: 40px;
  width: 100%;
  padding: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.xendit-channel-form-field .xendit-iframe-container iframe {
  height: 40px;
  width: 100%;
  border: none;
  min-width: 0;
}

.xendit-channel-form-field.xendit-form-field-span-1 {
  grid-column: span 1;
}

.xendit-channel-form-field.xendit-form-field-span-2 {
  grid-column: span 2;
}

.xendit-checkbox {
  display: flex;
  align-items: center;
}

.xendit-checkbox-box {
  display: flex;
}

.xendit-checkbox input {
  width: 16px;
  height: 16px;
  margin: 0;
  cursor: pointer;
}

.xendit-checkbox label {
  cursor: pointer;
  padding-left: 8px;
}

.xendit-checkbox input {
  opacity: 0;
  position: absolute;
}

.xendit-checkbox input + .xendit-checkbox-graphic {
  width: 16px;
  height: 16px;
  border: 1px solid var(--xendit-color-border);
  border-radius: 4px;
  box-sizing: border-box;
  color: transparent;
}

.xendit-checkbox input:checked + .xendit-checkbox-graphic {
  color: var(--xendit-color-background);
  background-color: var(--xendit-color-primary);
  border-color: var(--xendit-color-primary);
}

/* Dialog */

.xendit-dialog-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  padding: 48px;
  justify-content: center;
  align-items: center;
}

.xendit-dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--xendit-color-background);
  padding: 8px 0;
  gap: 16px;
  line-height: 24px;
}

.xendit-dialog-header button {
  background: none;
  border: none;
  color: var(--xendit-color-background);
  cursor: pointer;
  padding: 0;
}

.xendit-dialog-body {
  display: flex;
  background-color: var(--xendit-color-background);
  border-radius: 8px;
  padding: 8px;
}

.xendit-error-message {
  color: var(--xendit-color-danger);
}

/* Phone input Dropdown */
.xendit-input-phone .xendit-combobox {
  display: flex;
  gap: 8px;
}

.xendit-phone-number-input {
  width: 100%;
}

.xendit-input-phone .xendit-dropdown button {
  width: 64px;
}

.xendit-input-phone .xendit-dropdown button .xendit-dropdown-button-title {
  display: none;
}

.xendit-dropdown .xendit-dropdown-search input {
  padding: 8px;
  border: 1px solid var(--xendit-color-border-subtle);
  border-radius: var(--xendit-radius-1);
  box-sizing: border-box;
}

.xendit-dropdown-search input:focus {
  outline: none;
  border-color: var(--xendit-color-primary);
  box-shadow: var(--xendit-focus-shadow);
}

/* Phone input Dropdown ends */

/* Dropdown */
.xendit-dropdown button {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 8px;
  text-align: left;
  background-color: var(--xendit-color-background);
  border: 1px solid var(--xendit-color-border-subtle);
  border-radius: var(--xendit-radius-1);
  justify-content: space-between;
  padding: 12px;
  cursor: pointer;
}

.xendit-dropdown button.xendit-dropdown-has-asset {
  grid-template-columns: auto 1fr auto;
}

.xendit-dropdown button:disabled {
  background: var(--xendit-color-disabled);
}

.xendit-dropdown button:focus {
  outline: none;
  border: 1px solid var(--xendit-color-primary);
  box-shadow: 0px 0px 0px 2px #1762ee26;
}

.xendit-dropdown-menu {
  position: absolute;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 168px;
  width: 257px;
  padding: 4px;
  margin: 4px 0;
  background-color: var(--xendit-color-background);
  border: 1px solid var(--xendit-color-border);
  border-radius: var(--xendit-radius-1);
  list-style: none;
  box-shadow: 0px 4px 8px 0px #25252514;
  overflow-y: auto;
}

.xendit-dropdown-menu ul {
  list-style: none;
  padding: 4px;
  margin-top: 0;
}

.xendit-dropdown-search {
  position: sticky;
  top: 0;
  z-index: 1;
}

.xendit-dropdown-search input {
  width: 100%;
}

.xendit-dropdown-item {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 8px;
  padding: 8px 12px 8px 4px;
  border-radius: var(--xendit-radius-1);
  cursor: pointer;
  z-index: 0;
  --xendit-dropdown-item-hover-color: var(--xendit-color-background);
  --xendit-dropdown-item-hover-bg-color: var(--xendit-color-primary);
}

.xendit-dropdown-item-disabled {
  --xendit-dropdown-item-hover-color: var(--xendit-color-text);
  --xendit-dropdown-item-hover-bg-color: var(--xendit-color-disabled);
}

.xendit-dropdown-item:hover {
  background-color: var(--xendit-dropdown-item-hover-bg-color);
}

.xendit-dropdown-item:hover .xendit-dropdown-item-text,
.xendit-dropdown-item:hover .xendit-dropdown-item-description {
  color: var(--xendit-dropdown-item-hover-color);
}

.xendit-dropdown-item-selected {
  color: var(--xendit-color-primary);
}

.xendit-dropdown-item:hover .xendit-dropdown-item-selected {
  color: var(--xendit-dropdown-item-hover-color);
}

.xendit-dropdown-item.xendit-dropdown-has-asset {
  grid-template-columns: auto 1fr auto;
}

.xendit-dropdown-item-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.xendit-dropdown-item-disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.xendit-dropdown-item-disabled:hover,
.xendit-dropdown-item-disabled.is-active {
  background-color: var(--xendit-color-disabled);
}

/* Dropdown ends */
